import { render, staticRenderFns } from "./version-card.vue?vue&type=template&id=693771f2"
import script from "./version-card.vue?vue&type=script&lang=js"
export * from "./version-card.vue?vue&type=script&lang=js"
import style0 from "./version-card.vue?vue&type=style&index=0&id=693771f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports